let BASE_API: string | undefined,
  AUTH_URL: string | undefined,
  LOGOUT_URL: string | undefined,
  AUTH_SCOPE: string | undefined,
  AUTH_CLIENT_ID: string | undefined,
  GA_TRACKING_ID: string | undefined,
  SENTRY_DSN: string | undefined,
  SENTRY_ENVIRONMENT: string | undefined

const isTestEnv = process.env.NODE_ENV === 'test'

const MSW_ENABLED = false

if (isTestEnv) {
  BASE_API = 'https://dev.palco.g.globo/api'
  AUTH_URL = 'https://id.qa.globoi.com/auth/realms/globoi/protocol/openid-connect/auth'
  LOGOUT_URL = 'https://id.qa.globoi.com/auth/realms/globoi/protocol/openid-connect/logout '
  AUTH_SCOPE = 'email openid profile'
  AUTH_CLIENT_ID = 'gplar'
  GA_TRACKING_ID = 'G-KLEDQCX6YZ'
  SENTRY_DSN = 'https://2a86d2db0f3246d999ce3ee79f5a85c5@web.sentry.qa01.globoi.com/394'
  SENTRY_ENVIRONMENT = 'development'
} else {
  BASE_API = process.env.REACT_APP_BASE_API
  AUTH_URL = process.env.REACT_APP_AUTH_URL
  LOGOUT_URL = process.env.REACT_APP_LOGOUT_URL
  AUTH_SCOPE = process.env.REACT_APP_AUTH_SCOPE
  AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID
  GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID
  SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
  SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT
}
export {
  BASE_API,
  MSW_ENABLED,
  AUTH_URL,
  LOGOUT_URL,
  AUTH_SCOPE,
  AUTH_CLIENT_ID,
  GA_TRACKING_ID,
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
}
